import React from 'react';
import CenteredActivityResponseText from '../CenteredActivityResponseText/CenteredActivityResponseText';

const DeferredPaymentErrorDetails = ({ ramqResponse }) =>
  ramqResponse.errorMessages.map((message) => <CenteredActivityResponseText key={message} text={message} />);

export default DeferredPaymentErrorDetails;
